import { render, staticRenderFns } from "./InventorySummaryTable.vue?vue&type=template&id=27f2b53b&scoped=true&"
import script from "./InventorySummaryTable.vue?vue&type=script&lang=js&"
export * from "./InventorySummaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f2b53b",
  null
  
)

export default component.exports